export function LoginScreen({ label }: { label: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen items-center justify-center p-8"
    >
      <div className="flex flex-col items-center gap-4">
        <div
          className="h-14 w-14 rounded-full"
          style={{
            backgroundColor: "#F28132",
            animation: "pulse-glow 1.8s ease-in-out infinite"
          }}
          aria-hidden="true"
        />
        <p className="text-xs uppercase tracking-[0.25em] text-white/60">
          {label}
        </p>
      </div>
    </div>
  );
}
